export default __webpack_public_path__ + "static/media/near01.b04393aa.png";